import { Injectable } from '@angular/core';
import { DataContextService } from './data-context.service';
import { CoreService } from './core.service';

/**
 * Service that provides context and functionality for plugins
 * Handles globe interactions and provides access to core services
 */
@Injectable({
  providedIn: 'root'
})
export class PluginContextService {
  constructor(
    private dataContext: DataContextService,
    private core: CoreService
  ) {}

  /**
   * Gets the data context service
   * @returns The data context service instance
   */
  getDataContext(): DataContextService {
    return this.dataContext;
  }

  /**
   * Adds a click listener to the globe
   * @param object The object to bind the listener to
   * @param listener The click listener function
   */
  addGlobeClickListener(object: any, listener :any): void {
    this.core.addGlobeClickListener(object, listener);
  }

  /**
   * Removes a click listener from the globe
   * @param object The object whose listener should be removed
   */
  removeGlobeClickListener(object: any): void {
    this.core.removeGlobeClickListener(object);
  }

  /**
   * Gets the current scene
   * @returns The current scene instance
   */
  getScene(): any {
    return this.core.getScene();
  }

  /**
   * Gets the current viewer
   * @returns The current viewer instance
   */
  getViewer(): any {
    return this.core.getViewer();
  }
}